<mat-expansion-panel>
  <mat-expansion-panel-header
    [ngClass]="history.category === 'fu_response' ? 'followup' : 'error-bounce'"
  >
    <mat-panel-title>
      <i
        class="fas"
        [ngClass]="history.category === 'fu_response' ? 'fa-bell' : 'fa-exclamation-circle'"
      ></i>
      <span
        class="history-title"
        *ngIf="leftBarHistoryCategories.includes(history.category)"
        [matTooltip]="history.createdTs | dateChecker"
      >
        <span>{{ leftBarHistoryCategoriesMap[history.category] | translate }}</span>
        <span>{{ 'ON' | translate }} {{ history.createdTs | dateCheckerNoHour }}</span>
      </span>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <app-permission-edit [permissionNames]="requiredPermissions" [style]="'text-center'" showFallback>
    <div *ngIf="history.mergedFromInteractionId" class="medis-flex-container-center mb-1">
      <i class="fa fa-info-circle text-14-azure me-1" aria-hidden="true"></i>
      <a routerLink="/detail/{{ history.mergedFromInteractionId }}" class="clickable">
        {{ 'MERGED_FROM' | translate }} {{ 'INTERACTION' | translate }}
        {{ history.mergedFromInteractionId }}
      </a>
    </div>
    <div
      class="question-text"
      *ngIf="history?.text && (history.category == 'fu_response' || history.category == 'error')"
      [innerHtml]="history?.text | sanitizeHtml"
    ></div>
    <div class="question-text" *ngIf="history?.text && history.category == 'bounce_detected'">
      {{
        (history.historyDescription === 'fwd_history_id'
          ? 'FWD_TO_DEPT_FAILED'
          : history.historyDescription === 'gdpr_notif'
          ? 'GDPR_NOTIF_FAILED'
          : 'ANSWER_HAS_NOT_BEEN_SENT_TO_THE_INQ_'
        ) | translate
      }}
    </div>
    <div *ngFor="let link of attachments">
      <app-link-visualization
        [link]="link"
        [allowRemove]="false"
        [style]="'compact'"
        [canOpenFile]="loggedInUserIsSysAdmin || !link.isDeleted"
      ></app-link-visualization>
    </div>
    <button mat-button class="medis-button-basic mt-2" (click)="openHistory()">
      <i class="fas fa-eye"></i>
      {{ 'SHOW_ORIGINAL_MESSAGE' | translate }}
    </button>
    <button
      *ngIf="history.category === 'fu_response' && !isInteractionClosedOrInReview"
      mat-button
      class="medis-button-basic mt-2"
      (click)="createQuestionFromFU(history.pk())"
      [matTooltip]="'CREATE_QUESTION_FROM_FU_RESPONSE_TOOLTIP' | translate"
    >
      <i class="fas fa-plus"></i>
      {{ 'ADD_AS_A_NEW_QUESTION' | translate }}
    </button>
    <button
      *ngIf="
        history.category === 'bounce_detected' && history.historyDescription === 'fwd_history_id'
      "
      mat-button
      class="medis-button-basic mt-2"
      (click)="resendToDept()"
    >
      <i class="fas fa-redo"></i>
      {{ 'RESEND' | translate }}
    </button>
    <app-message [message]="message" class="w-100"></app-message>
  </app-permission-edit>
</mat-expansion-panel>
